export class OperationConstant {
  static LANDING_LABEL = "Débarquement";
  static BOARDING_LABEL = "Embarquement";

  static CONTAINER_ID = "CONTAINER";
  static BAG_ID = "BAG";
  static VEHICLE_ID = "VEHICLE";
  static CRAFT_ID = "CRAFT";
  static OTHER_ID = "OTHER";

  static MANIFESTO_TYPE = [
    {
      label: this.LANDING_LABEL,
    },
    {
      label: this.BOARDING_LABEL,
    },
  ];
}

export class ManifestoConstant {
  // static LANDING_LABEL = "Débarquement";
  // static BOARDING_LABEL = "Embarquement";
  // static MANIFESTO_TYPE = [
  //   {
  //     label: this.LANDING_LABEL,
  //   },
  //   {
  //     label: this.BOARDING_LABEL,
  //   },
  // ];

  static CONTAINER_EMPTY_ID = "/api/load_filling_statuses/EMPTY";
  static CONTAINER_FULL_ID = "/api/load_filling_statuses/FILLED";
}

export class EquipeManagementConstant {
  static CABOTAGE_ID = "/api/operation_categories/CABOTAGE";
  static OPERATION_COMMERCIAL_ID = "/api/operation_categories/COMMERCIAL";

  static CABOTAGE_LABEL = "Cabotage";
  static OPERATION_COMMERCIAL_LABEL = "Ops com";

  static TEAM_MANGEMENT_TYPE = [
    {
      label: this.OPERATION_COMMERCIAL_LABEL,
      value: this.OPERATION_COMMERCIAL_ID,
    },
    {
      label: this.CABOTAGE_LABEL,
      value: this.CABOTAGE_ID,
    },
  ];
}

export class ActivityConstant {
  static ACTIVITY_ID = "activity";
  static TRAINING_ID = "training";

  static ACTIVITY_LABEL = "Activités journalières";
  static TRAINING_LABEL = "Formations";

  static ACTIVITY_TYPE = [
    {
      label: this.ACTIVITY_LABEL,
      value: this.ACTIVITY_ID,
    },
    {
      label: this.TRAINING_LABEL,
      value: this.TRAINING_ID,
    },
  ];
}

export class ShiftingConstant {
  static SHIFTING_ID = "shifting";
  static HATCH_COVER_ID = "hatch";
  static WAITING_TIME_ID = "waiting";

  static SHIFTING_LABEL = "Ops shifting";
  static HATCH_COVER_LABEL = "Ops de panneau de cale";
  static WAITING_TIME_LABEL = "Temps d'attente";

  static SHIFTING_TYPE = [
    {
      label: this.SHIFTING_LABEL,
      value: this.SHIFTING_ID,
    },
    {
      label: this.HATCH_COVER_LABEL,
      value: this.HATCH_COVER_ID,
    },
    {
      label: this.WAITING_TIME_LABEL,
      value: this.WAITING_TIME_ID,
    },
  ];
}

export class PlanningConstant {
  static TEAM_ON_BOARD_ID = "/api/team_types/TEAM_ON_BOARD";
  static TEAM_DOCKSIDE_ID = "/api/team_types/DOCKSIDE_TEAM";
  static TEAM_STORAGE_ID = "/api/team_types/STORAGE_TEAM";

  static MATERIAL_REQUEST_SEMS = "SEMS";
  static MATERIAL_REQUEST_COMAMA = "COMAMA";

  static TEAM_ON_BOARD_LABEL = "EQUIPE À BORD";
  static TEAM_DOCKSIDE_LABEL = "EQUIPE À QUAI";
  static TEAM_STORAGE_LABEL = "EQUIPE ENTREPOSAGE";

  static TEAMS_OPTION = [
    {
      label: this.TEAM_ON_BOARD_LABEL,
      value: this.TEAM_ON_BOARD_ID,
    },
    {
      label: this.TEAM_DOCKSIDE_LABEL,
      value: this.TEAM_DOCKSIDE_ID,
    },
    {
      label: this.TEAM_STORAGE_LABEL,
      value: this.TEAM_STORAGE_ID,
    },
  ];

  static MATERIAL_REQUEST_TYPE = [
    {
      label: this.MATERIAL_REQUEST_SEMS,
      value: this.MATERIAL_REQUEST_SEMS,
    },
    {
      label: this.MATERIAL_REQUEST_COMAMA,
      value: this.MATERIAL_REQUEST_COMAMA,
    },
  ];
}

export class PointingConstant {
  static CHECKPOINT_OK = "OK";
  static CHECKPOINT_NOK = "NOK";
  static CHECKPOINT_IN_PROGRESS = "IN_PROGRESS";
  static POINING_BOARD = "POINTING_ON_BOARD";
  static POINING_DOCKSIDE = "POINTING_DOCKSIDE";
}
